import { Button } from '@/components'
import { FlexWrapper } from '@/components/layout/flex/flexWrapper'
import { useAxios } from '@/context/axiosContext'
import { useDialog } from '@/context/dialogContext'
import { useAppSelector } from '@/redux/hooks'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

const TitleContainer = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 10px;
`

const SubTitleContainer = styled.div`
  width: 80%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px; /* 버튼 간격 조정 */
`

const Title = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
`

const CompanyName = styled.span`
  font-size: 18px;
  font-weight: normal;
`

const SaveButton = styled.button`
  background-color: #d09d30;
  color: white;
  border: none;
  padding: 10px 25px;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 10px;

  &:hover {
    background-color: #b88729;
  }

  &:focus {
    background-color: #e0ae4c;
  }
`

const BackButton = styled.button`
  background-color: #b6b6b6;
  color: white;
  border: none;
  padding: 10px 25px;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 10px;

  &:hover {
    background-color: rgb(155, 155, 155);
  }

  &:focus {
    background-color: rgb(167, 167, 167);
  }
`

const TableContainer = styled.div`
  width: 80%;
  display: grid;
  grid-template-columns: 0.2fr 0.5fr 0.4fr 0.4fr 1.3fr 0.1fr; /* 컬럼 갯수 수정 */
  gap: 10px;
  margin-top: 10px;
`

const HeaderRow = styled.div`
  display: contents;
  background-color: #f5f5f5;
  font-weight: bold;
  text-align: center;
`

const HeaderCell = styled.div`
  padding: 10px 15px;
  border: 1px solid #000;
  text-align: center;
  background-color: #b6b6b6;
  color: white;
`

const Row = styled.div`
  display: contents;
  align-items: center;
  background-color: #f9f9f9;

  &:nth-child(even) {
    background-color: #f2f2f2;
  }
`

const Cell = styled.div`
  padding: 10px 15px;
  border: 1px solid #ccc;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`

const NoDataCell = styled.div`
  grid-column: 1 / -1; /* 전체 컬럼을 병합 */
  text-align: center; /* 가운데 정렬 */
  padding: 20px;
  font-size: 16px;
  color: #999;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
`

const Input = styled.input`
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
`

const TestButton = styled.button`
  color: #d09d30;
  border: 1px solid #d09d30;
  background-color: transparent;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    color: #fff;
    background-color: #d09d30;
  }

  &:focus {
    color: #fff;
    background-color: #e0ae4c;
  }
`

interface ScrpInfoData {
  cmpnyCd: string
  bizCd: string
  bizNm: string
  glfPrceCd: string
  codeNm: string
  selector: string
  rem: string
  regId: string
  updId: string
  chrgeDomain?: string
}

const ScrpingMgmtPage = () => {
  const axios = useAxios()
  const { showAlert, showConfirm } = useDialog()
  const { user } = useAppSelector((state) => state.auth)
  const navigate = useNavigate()
  const location = useLocation()

  const bizCd = location.state?.bizCd

  const [bizNm, setBizNm] = useState<string>('')
  const [scrpDatas, setScrpDatas] = useState<ScrpInfoData[]>([])

  const moveBack = () => {
    const page = location.state?.prevPage
    if (page === 'batch') {
      navigate(-1)
    } else {
      navigate('/bizMgmt', {
        state: { bizSearchState: location.state?.bizSearchState },
      })
    }
    // showConfirm({
    //   title: `${page === 'batch' ? '배치실패현황' : '업체관리'} 화면으로 이동할까요?`,
    //   onConfirm() {
    //     if (page === 'batch') {
    //       navigate(-1)
    //     } else {
    //       navigate('/bizMgmt', {
    //         state: { bizSearchState: location.state?.bizSearchState },
    //       })
    //     }
    //   },
    // })
  }

  const fetchInqrScrpInfo = async () => {
    try {
      const res = await axios.get('/scrpMgmt/inqr', {
        params: { bizCd: bizCd },
      })
      if (res.data.common.resultCode === 'SCRPS0200') {
        const tmp_data = res.data.data.scrpInfoList
        for (let i = 0; i < tmp_data.length; i++) {
          tmp_data[i].regId = user.userId
          tmp_data[i].updId = user.userId
        }
        setScrpDatas(tmp_data)
        setBizNm(tmp_data[0].bizNm)
      }
    } catch (err) {
      console.error(err)
    }
  }

  const fetchUpdateScrpInfo = async () => {
    try {
      for (let i = 0; i < scrpDatas.length; i++) {
        const selector = scrpDatas[i].selector
        if (
          selector != '' &&
          selector != undefined &&
          selector != null &&
          !isValidFormat(selector)
        ) {
          showAlert({
            type: 'warning',
            message:
              'selector 정보를 확인해주세요.\n정확한 형식에 맞춰 작성해주세요.',
          })
          return
        }
      }
      const res = await axios.post('/scrpMgmt/update', { infos: scrpDatas })

      if (res.data.common.resultCode === 'SCRPU0200') {
        showAlert({ type: 'success', message: '저장이 완료되었어요.' })
      } else {
        showAlert({ type: 'error', message: '정보 업데이트에 실패했어요.' })
      }
    } catch (err) {
      showAlert({
        title: '오류가 발생했어요. 잠시 후 다시 시도해주세요.',
      })
      console.error(err)
    }
  }

  const fetchTestScrpInfo = async (idx: number) => {
    try {
      const testData = scrpDatas[idx]
      if (testData.selector == undefined || testData.selector == '') {
        showAlert({ type: 'warning', message: 'selector칸을 확인해주세요.' })
        return
      } else if (!isValidFormat(testData.selector)) {
        showAlert({
          type: 'warning',
          message: '올바르지 않은 형태의 데이터예요.\n영어:숫자|영어:숫자...',
        })
        return
      }
      const response = await axios.post('/scrpMgmt/test', { ...testData })
      const common = response.data.common
      if (response.data.common.resultCode === 'SCRPT0200') {
        showAlert({ type: 'success', message: response.data.data.price })
      } else {
        showAlert({
          type: 'error',
          message: `${common.resultCode}\n${common.resultMsg}`,
        })
      }
    } catch (err) {
      console.error(err)
    }
  }

  const updateValue = (
    index: number,
    key: keyof ScrpInfoData,
    newVal: string,
  ) => {
    setScrpDatas((prevDats) =>
      prevDats.map((item, idx) =>
        idx === index ? { ...item, [key]: newVal } : item,
      ),
    )
  }

  const isValidFormat = (input: string) => {
    const regex =
      /^[A-Za-z]+(?:\s[A-Za-z]+)*:[0-9]+(?:\|[A-Za-z]+(?:\s[A-Za-z]+)*:[0-9]+)*$/
    return regex.test(input)
  }

  useEffect(() => {
    fetchInqrScrpInfo()
  }, [])

  return (
    <Container>
      <TitleContainer>
        <Title>스크래핑 관리</Title>
      </TitleContainer>
      <SubTitleContainer>
        <CompanyName>
          업체명:{' '}
          <span
            style={{ cursor: 'pointer' }}
            onClick={() =>
              window.open(scrpDatas[0].chrgeDomain || '', '_blank')
            }
          >
            {bizNm}
          </span>
        </CompanyName>
        <FlexWrapper gap="20px">
          <Button color="neverbe" onClick={moveBack} variant="outlined">
            목록
          </Button>
          <Button
            color="neverbe"
            onClick={() => {
              showConfirm({
                title: '변경사항을 저장할까요?',
                onConfirm() {
                  fetchUpdateScrpInfo()
                },
              })
            }}
          >
            저장
          </Button>
        </FlexWrapper>
      </SubTitleContainer>
      <TableContainer>
        <HeaderRow>
          <HeaderCell>No.</HeaderCell>
          <HeaderCell>업체코드</HeaderCell>
          <HeaderCell>가격코드</HeaderCell>
          <HeaderCell>가격코드명</HeaderCell>
          <HeaderCell>Selector</HeaderCell>
          <HeaderCell>Test</HeaderCell>
        </HeaderRow>
        {scrpDatas.length > 0 ? (
          scrpDatas.map((item, idx) => (
            <Row key={idx}>
              <Cell>{idx + 1}</Cell>
              <Cell>{item.bizCd}</Cell>
              <Cell>{item.glfPrceCd}</Cell>
              <Cell>{item.codeNm}</Cell>
              <Cell>
                <Input
                  defaultValue={item.selector}
                  onChange={(e) => {
                    updateValue(idx, 'selector', e.target.value)
                  }}
                />
              </Cell>
              <Cell>
                <TestButton
                  onClick={() => {
                    fetchTestScrpInfo(idx)
                  }}
                >
                  Test
                </TestButton>
              </Cell>
            </Row>
          ))
        ) : (
          <Row>
            <NoDataCell>정보 조회에 실패했어요</NoDataCell>
          </Row>
        )}
      </TableContainer>
    </Container>
  )
}

export default ScrpingMgmtPage
